'use client';

import { useState } from 'react';

import { McsApi } from '~services/McsApi';
import { DatasetActionValues } from '~types/Dataset.types';
import { URLS } from '~types/Urls.types';

export const useUiActions = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAction = async (
    actionType: DatasetActionValues,
    target: HTMLAnchorElement | HTMLButtonElement,
  ) => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      switch (actionType) {
        case DatasetActionValues.appLink:
          window.location.assign(target.getAttribute('href') || URLS.App);
          break;
        case DatasetActionValues.signIn:
          await McsApi.signIn(() => {
            window.location.assign(target.getAttribute('href') || URLS.App);
          });
          break;
        case DatasetActionValues.signUp:
          await McsApi.signUp(() => {
            window.location.assign(target.getAttribute('href') || URLS.App);
          });
          break;
        case DatasetActionValues.signOut:
          await McsApi.signOut();
          break;
        default:
          console.warn(`Unhandled action: ${actionType}`);
      }
    } catch (error) {
      console.error(`Action ${actionType} failed:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleAction,
    isLoading,
  };
};
